/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";

// Models
import { Chart, ComparedData } from "@/models/api/statistics/Statistics";
import { getChart, getStatistics } from "@/requests/statistics";

export interface StatisticsStateInterface {
  bookingChart: null | Chart;
  dashboardData: Array<ComparedData>;
}

export const ContractorsState: StatisticsStateInterface = {
  bookingChart: null,
  dashboardData: [],
};

const ContractorsModule = defineModule({
  state: ContractorsState as StatisticsStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setBookingChart(state, param: null | Chart) {
      state.bookingChart = param;
    },
    setDashboardData(state, param: null | Array<ComparedData>) {
      state.dashboardData = param ?? [];
    },
  },
  actions: {
    async getStatistics(context) {
      const { commit } = _moduleActionContext(context);
      const result = await getStatistics();
      commit.setDashboardData(result.dashboardData);
    },
    async getChart(context, name: string): Promise<Chart> {
      const result = await getChart(name);
      return result;
    },
  },
});

export default ContractorsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, ContractorsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, ContractorsModule);
